import { render, staticRenderFns } from "./EbSwitch.vue?vue&type=template&id=65963544"
import script from "./EbSwitch.vue?vue&type=script&lang=js"
export * from "./EbSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports